(() => {
  const marker = 'msChatPositionReady';
  if (document.documentElement.dataset[marker]) return;
  document.documentElement.dataset[marker] = 'true';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const targets = '.ms-sticky-purchase, .shop-ai-chat-container, cart-drawer, .quick-add-modal';
  const overlaySelector = 'cart-drawer.active, .quick-add-modal[open], .quick-add-modal[aria-hidden="false"]';
  let bar;
  let container;
  let frame = 0;
  let releaseTimer = 0;
  let wasActive = false;

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const attributes = new MutationObserver(schedule);
  const dimensions = new ResizeObserver(schedule);

  function reset() {
    clearTimeout(releaseTimer);
    releaseTimer = 0;
    wasActive = false;
    container?.classList.remove('ms-chat-with-purchase', 'ms-chat-beside-purchase', 'ms-chat-obscured');
    container?.style.removeProperty('--ms-chat-purchase-lift');
    container?.style.removeProperty('--ms-chat-purchase-shift');
  }

  function update() {
    frame = 0;
    if (!container || !bar || !bar.isConnected) {
      reset();
      return;
    }

    const obscured = Boolean(document.querySelector(overlaySelector));
    container.classList.toggle('ms-chat-obscured', obscured);
    const style = getComputedStyle(bar);
    const active = !obscured && bar.classList.contains('is-visible') &&
      bar.getAttribute('aria-hidden') !== 'true' && style.display !== 'none' && bar.getBoundingClientRect().height > 0;

    if (active) {
      clearTimeout(releaseTimer);
      releaseTimer = 0;
      wasActive = true;
      const rect = bar.getBoundingClientRect();
      const inset = parseFloat(style.bottom) || 0;
      const launcherInset = parseFloat(getComputedStyle(container).bottom) || 0;
      const launcherRight = container.getBoundingClientRect().right;
      const availableRight = Math.min(launcherRight, document.documentElement.clientWidth - 16);
      const iconSize = 56;
      const sideRight = rect.right + 20 + iconSize;
      const beside = sideRight <= availableRight;
      const targetRight = beside ? sideRight : Math.min(rect.right, availableRight);
      const lift = Math.max(0, inset + (beside ? (rect.height - iconSize) / 2 : rect.height + 16) - launcherInset);
      const offsets = {
        '--ms-chat-purchase-lift': Math.ceil(lift * 100) / 100,
        '--ms-chat-purchase-shift': Math.floor((targetRight - launcherRight) * 100) / 100
      };
      Object.entries(offsets).forEach(([property, offset]) => {
        const value = `${offset}px`;
        if (container.style.getPropertyValue(property) !== value) container.style.setProperty(property, value);
      });
      container.classList.toggle('ms-chat-beside-purchase', beside);
      container.classList.add('ms-chat-with-purchase');
      return;
    }

    if (wasActive) {
      wasActive = false;
      const seconds = value => value.trim().endsWith('ms') ? parseFloat(value) : parseFloat(value) * 1000;
      const durations = style.transitionDuration.split(',').map(seconds);
      const delays = style.transitionDelay.split(',').map(seconds);
      const duration = reducedMotion.matches || obscured ? 0 : Math.max(...durations.map((time, index) => time + (delays[index % delays.length] || 0)));
      releaseTimer = window.setTimeout(() => {
        releaseTimer = 0;
        container?.classList.remove('ms-chat-with-purchase', 'ms-chat-beside-purchase');
        container?.style.removeProperty('--ms-chat-purchase-lift');
        container?.style.removeProperty('--ms-chat-purchase-shift');
      }, duration + (duration ? 20 : 0));
    }
  }

  function bind() {
    const nextContainer = document.querySelector('.shop-ai-chat-container');
    const nextBar = Array.from(document.querySelectorAll('.ms-sticky-purchase')).find(element => !element.closest('quick-add-modal'));
    if (nextContainer !== container || nextBar !== bar) reset();
    container = nextContainer;
    bar = nextBar;
    attributes.disconnect();
    dimensions.disconnect();
    if (container && bar) {
      attributes.observe(bar, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'style'] });
      dimensions.observe(bar);
      dimensions.observe(container);
      document.querySelectorAll('cart-drawer, .quick-add-modal').forEach(element => {
        attributes.observe(element, { attributes: true, attributeFilter: ['class', 'open', 'aria-hidden'] });
      });
    }
    schedule();
  }

  function init() {
    bind();
    const discovery = new MutationObserver(records => {
      const relevant = records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
        node.nodeType === 1 && (node.matches(targets) || node.querySelector(targets))
      ));
      if (relevant) bind();
    });
    discovery.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', bind);
    document.addEventListener('shopify:section:unload', bind);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', bind);
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    reducedMotion.addEventListener('change', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
